import { Outlet, createFileRoute } from '@tanstack/react-router'
import { AppProvider } from '@/providers'
import { RxdbSplashGate } from '@/components/app/RxdbSplashGate'
import { AuthRefreshGate } from '@/components/app/AuthRefreshGate'
import { WorkspaceLimitDialog } from '@/components/app/WorkspaceLimitDialog'

export const Route = createFileRoute('/_AppWrapper')({
  component: RootComponent,
})

/**
 * AppWrapper component
 *
 * This component used to integrate Electric SQL with PGlite for local-first sync.
 * It has been migrated to use RxDB for data synchronization.
 *
 * Electric SQL imports and PGlite setup have been removed as part of the migration.
 * Database initialization is now handled by RxDB in the lib/db/rxdb directory.
 */
function RootComponent() {
  return (
    <AppProvider>
      <AuthRefreshGate>
        <RxdbSplashGate>
          <Outlet />
        </RxdbSplashGate>
        <WorkspaceLimitDialog />
      </AuthRefreshGate>
    </AppProvider>
  )
}
